export var WebSocketProxyEvents;

(function (WebSocketProxyEvents) {
  WebSocketProxyEvents["OnLoginSuccess"] = "onloginsuccess";
  WebSocketProxyEvents["OnWebSocketDisconnected"] = "onwebsocketdisconnected";
  WebSocketProxyEvents["OnJoinRoomSuccess"] = "onjoinroomsuccess";
  WebSocketProxyEvents["OnOfferFromPeer"] = "onofferfrompeer";
  WebSocketProxyEvents["OnSignalFromPeer"] = "onsignalfrompeer";
  WebSocketProxyEvents["OnForcedLoggedOut"] = "onforcedloggedout";
})(WebSocketProxyEvents || (WebSocketProxyEvents = {}));

export var UIEvents;

(function (UIEvents) {
  UIEvents["OnCallEndClicked"] = "oncallendclicked";
  UIEvents["OnShowMyVideoClicked"] = "onshowmyvideoclicked";
  UIEvents["OnFlipCameraClicked"] = "onflipcameraclicked";
  UIEvents["OnMuteAudioClicked"] = "onmuteaudioclicked";
  UIEvents["OnTurnOffVideoClicked"] = "onturnoffvideoclicked";
  UIEvents["OnSystemMessagePosted"] = "onsystemmessageposted";
  UIEvents["OnJoinCallClicked"] = "onjoincallclicked";
})(UIEvents || (UIEvents = {}));